import React, { Component } from "react";
import { Link } from "react-router-dom";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import Constants from "../../AppConstants/Constants";
import Utilities from "../../Helpers/Utilities";
import styled from "styled-components";
import CartItem from "./CartItem";

const Panel = styled.div`
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        padding-right: 15px;
        padding-left: 15px;
    }
`;

const SubTotalContainer = styled.div`
    margin-top: 20px;
    
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        margin-right: 0;
        margin-left: 0;
    }
`;

const SubtotalHeader = styled.h4`
    margin-bottom: 0;
`;

const CustomRow = styled.div`
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        margin-right: 0;
        margin-left: 0;
    }

    // Medium devices (tablets, 768px and up)
    @media (max-width: 991.98px) {
        &:last-child {
          margin-bottom: 20px;
        }
    }
`;

class CartPanel extends Component {
    constructor(props) {
        super(props);

        this.renderItems = this.renderItems.bind(this);
    }

    renderItems() {
        const { items, showDescription } = this.props;

        return _.map(items, item =>
            <CartItem key={`${item.id}_${item.quantity}`} item={item} showDescription={showDescription}/>
        );
    }

    render() {
        const { title, items } = this.props;
        const totalAmount =_.reduce(items, function(sum, item) {
            return sum + item.subTotalValue;
        }, 0);

        return (
            <Panel className="boxed boxed--border bg--secondary box-shadow">
                <h4>{title}</h4>

                <div className="panel-content">
                    {this.renderItems()}
                </div>

                {title === I18n.t("cart.panels.accessories") &&
                <SubTotalContainer className="row">
                    <div className="col-12 col-lg-7 col-xl-8">
                        <CustomRow className="row">
                            <div className="col-12">
                                <p className="type--italic">
                                    <Translate value="cart.panels.accessoriesMessage" />
                                </p>
                            </div>
                        </CustomRow>
                        <CustomRow className="row">
                            <div className="col-6 col-md-4">
                                <Link to={Constants.ENDPOINTS.ZEBRA_ACCESSORIES}><Translate value="accessories.title" name="Zebra" /></Link>
                            </div>
                            <div className="col-6 col-md-4">
                                <Link to={Constants.ENDPOINTS.PANASONIC_ACCESSORIES}><Translate value="accessories.title" name="Panasonic" /></Link>
                            </div>
                            <div className="col-6 col-md-4">
                                <Link to={Constants.ENDPOINTS.UNIVERSAL_ACCESSORIES}><Translate value="accessories.title" name="Universal" /></Link>
                            </div>
                        </CustomRow>
                    </div>
                    <div className="col-7 col-md-9 col-lg-3 col-xl-2 text-right">
                        <SubtotalHeader><Translate value="misc.subTotal" /></SubtotalHeader>
                    </div>
                    <div className="col-5 col-md-3 col-lg-2 text-right">
                        {title.toLowerCase().includes("services") ? <SubtotalHeader>{Utilities.formatPrice(totalAmount)}/<Translate value="misc.month" /></SubtotalHeader> : <SubtotalHeader>{Utilities.formatPrice(totalAmount)}</SubtotalHeader>}
                    </div>
                </SubTotalContainer>
                }

                {title !== I18n.t("cart.panels.accessories") &&
                <SubTotalContainer className="row">
                    <div className="col-7 col-md-9 text-right">
                        <SubtotalHeader><Translate value="misc.subTotal" /></SubtotalHeader>
                    </div>
                    <div className="col-5 col-md-3 text-right">
                        {title.toLowerCase().includes("services") ? <SubtotalHeader>{Utilities.formatPrice(totalAmount)}/<Translate value="misc.month" /></SubtotalHeader> : <SubtotalHeader>{Utilities.formatPrice(totalAmount)}</SubtotalHeader>}
                    </div>
                </SubTotalContainer>
                }
            </Panel>
        );
    }
}

export default CartPanel;